/**
 * Caution: Consider this file when using react-scripts
 *
 * You may delete this file and its occurrences from the project filesystem if you are using GatsbyJS or NextJS version
 */
import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import PrivacyPolicies from 'views/FooterPages/PrivacyPolicies';
import TermsAndConitions from 'views/FooterPages/TermsAndConditions';
import WithLayout from 'WithLayout';
import {Main as MainLayout, Minimal as MinimalLayout} from './layouts';

import {
    Home as HomeView,
    NotFound as NotFoundView,
    LatestNews as LatestNewsView,
    LatestNewsDetails as LatestNewsDetailsView,
    Reports as ReportsView,
    Legislation as LegislationView,
    Statistics as StatisticsView,
    Budget as BudgetView,
    Search as SearchView,
    NationalIndicators as NationalIndicatorsView,
    LocalIndicators as LocalIndicatorsView,
} from './views';

const Routes = () => {
    return (
        <Switch>
            <Route
                exact
                path='/'
                render={(matchProps) => <WithLayout {...matchProps} component={HomeView} layout={MainLayout}/>}
            />
            <Route
                exact
                path='/latest-news/:newsId'
                render={(matchProps) => <WithLayout {...matchProps} component={LatestNewsDetailsView}
                                                    layout={MainLayout}/>}
            />
            <Route
                exact
                path='/latest-news'
                render={(matchProps) => <WithLayout {...matchProps} component={LatestNewsView} layout={MainLayout}/>}
            />

            <Route
                exact
                path='/reports'
                render={(matchProps) => <WithLayout {...matchProps} component={ReportsView} layout={MainLayout}/>}
            />
            <Route
                exact
                path='/legislation'
                render={(matchProps) => <WithLayout {...matchProps} component={LegislationView} layout={MainLayout}/>}
            />
            <Route
                exact
                path='/financial-statistics'
                render={(matchProps) => <WithLayout {...matchProps} component={StatisticsView} layout={MainLayout}/>}
            />
            <Route
                exact
                path='/national-indicators'
                render={(matchProps) => <WithLayout {...matchProps} component={NationalIndicatorsView} layout={MainLayout}/>}
            />
            <Route
                exact
                path='/local-indicators'
                render={(matchProps) => <WithLayout {...matchProps} component={LocalIndicatorsView} layout={MainLayout}/>}
            />
            <Route
                exact
                path='/budget'
                render={(matchProps) => <WithLayout {...matchProps} component={BudgetView} layout={MainLayout}/>}
            />
            <Route
                exact
                path='/search'
                render={(matchProps) => <WithLayout {...matchProps} component={SearchView} layout={MainLayout}/>}
            />
            <Route
                exact
                path='/privacy-policies'
                render={(matchProps) => <WithLayout {...matchProps} component={PrivacyPolicies} layout={MainLayout}/>}
            />
            <Route
                exact
                path='/terms-conditions'
                render={(matchProps) => <WithLayout {...matchProps} component={TermsAndConitions} layout={MainLayout}/>}
            />
            <Route
                exact
                path='/not-found'
                render={(matchProps) => <WithLayout {...matchProps} component={NotFoundView} layout={MinimalLayout}/>}
            />
            <Redirect to='/'/>
        </Switch>
    );
};

export default Routes;
